import { render } from "./addMember.vue?vue&type=template&id=08b8b961&scoped=true"
import script from "./addMember.vue?vue&type=script&lang=js"
export * from "./addMember.vue?vue&type=script&lang=js"

import "./addMember.vue?vue&type=style&index=0&id=08b8b961&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b8b961"]])

export default __exports__